import { CommonPrefix, Object } from "aws-sdk/clients/s3";
import { FILE_EXTENSION_WITH_THUMBNAIL, THUMB_EXT } from "config";
import { filesize } from "filesize";
import moment from "moment";
import { BucketFile, BucketFolder, FileExtensionType } from "types";
import { getFileExtension } from "utils/bucketContent";

export const folderFactory = (item: CommonPrefix): BucketFolder => {
  const { Prefix = "" } = item;
  const levels = Prefix.split("/");
  const numLevels = levels.length;
  const name = levels[numLevels - 2];
  return { fullPath: Prefix, name };
};

const getDaysDifferenceFromToday = (value?: Date) => {
  const today = moment().startOf("day");
  const expectedDay = moment(value).startOf("day");
  if (expectedDay.isValid()) {
    const duration = expectedDay.diff(today, "days");
    return duration;
  }
  return undefined;
};

const getFileExtensionType = (extension: string): FileExtensionType => {
  let type: FileExtensionType = "document";
  switch (extension) {
    case "jpg":
    case "png":
    case "jpeg":
      type = "image";
      break;
    case "pdf":
      type = "pdf";
      break;
    case "txt":
    case "odt":
      type = "text";
      break;
    case "doc":
    case "docx":
      type = "word";
      break;
    case "xls":
    case "xlsx":
      type = "excel";
      break;
    case "ods":
      type = "calc";
      break;
    default:
      type = "document";
      break;
  }
  return type;
};

export const fileFactory = (
  item: Object,
  fileWithThumbnail: Object[]
): BucketFile => {
  const { Key = "", LastModified, Size = 0, ETag = "" } = item;
  const levels = Key.split("/");
  const fileName = levels[levels.length - 1];
  const formattedLastModified = moment(LastModified).format(
    "DD/MM/YYYY HH:mm:ss"
  );
  const formattedSizeName = filesize(Size);
  const fileExtension = getFileExtension(Key);
  const fileExtensionType = getFileExtensionType(fileExtension);
  const creationDate = LastModified
    ? new Date(LastModified).getTime()
    : undefined;
  let thumbnail = undefined;

  if (FILE_EXTENSION_WITH_THUMBNAIL.includes(`.${fileExtension}`)) {
    const index = fileWithThumbnail.findIndex(
      (item) => item.Key === `${Key}.${THUMB_EXT}`
    );
    if (index !== -1) {
      thumbnail = fileWithThumbnail[index].Key;
    }
  }
  //aggiungo la scadenza
  let expireDate = LastModified ? new Date(LastModified) : undefined;
  expireDate?.setDate(expireDate?.getDate() + 180);
  const formattedExpirationDate = expireDate
    ? moment(expireDate).format("DD/MM/YYYY")
    : undefined;
  const expirationDays = getDaysDifferenceFromToday(expireDate);

  return {
    eTag: ETag,
    key: Key,
    fileName,
    size: Size,
    creationDate,
    formattedLastModified,
    formattedSizeName,
    fileExtension,
    fileExtensionType,
    formattedExpirationDate,
    expirationDays,
    thumbnail,
  };
};
